import { render, staticRenderFns } from "./companyIcon.vue?vue&type=template&id=f55e80e8&"
import script from "./companyIcon.vue?vue&type=script&lang=js&"
export * from "./companyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports